export default {
   api: "https://api.zjsleep.com",
    // api: "http://192.168.2.33:8087",
    // api:"http://wgkj72.natappfree.cc/"
}



// WEBPACK FOOTER //
// ./src/serve.js